import Vue from 'vue'
import VueRouter from 'vue-router'
import storage from 'store'
import store from '../store'
import { getUserMenusUsingGET } from '../api/dataapi'
import { getRouteObj } from './routeApi'

Vue.use(VueRouter)

const routes = [

]

const router = new VueRouter({
  base:  (process.env.NODE_ENV === 'production' ? '/uganda/general' : '/'),
  mode: 'history',
  routes,
})
router.beforeEach((to, from, next) => {
  document.querySelector('#app').style.background = '#000a3b';
  if(store.state.includeArr.includes(to.name)){
    store.dispatch('setTranstion', 'slide-right')
  }else{
    store.dispatch('setTranstion', 'slide-left')
  }
  store.dispatch('addInclude', to.name);

  const searchObj = function (search) {
    return JSON.parse('{"'.concat(decodeURIComponent(search.substring(1)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"'), '"}'))
  }
  const urlToken = location.search.length && searchObj(location.search).token ? searchObj(location.search).token : ''
  document.title = to.meta.title
  if(urlToken.length){
    storage.set('Access-Token', urlToken)
  }
  const token = storage.get('Access-Token')
  if (token) {
    //缓存内存在token
    if(!store.state.userMenu.length){
      //不存在
      getUserMenusUsingGET({
        modulename: 'uganda_portal'
      }).then(res => {
        if(res.length){
          store.dispatch('setUserMenu', res);
          getRouteObj(null, res);
          if(!res.find(val => val.path === to.path)){
            next({
              path: '/'
            })
          }else{
            const redirect = decodeURIComponent(from.query.redirect || to.path)
            if (to.path === redirect) {
              next({ ...to, replace: true })
            } else {
              next({ path: redirect })
            }
          }
        }else{
          return location.replace(
            `${location.origin}/user/work`
          )
        }
      })
    }else{
      next();
    }
  } else {
    //缓存内不存在token
    const str = location.href
    if(str.includes('token')){
      const hrefStr = str.replace("token=", '')
      return location.replace(
        `${location.origin}/user/sso/login?from=${hrefStr}`
      )
    }else{
      return location.replace(
        `${location.origin}/user/sso/login?from=${str}`
      )
    }
  }
})

export default router